<template>
    <div class="data-steps">
        <div class="data-steps__title">
            <h3>{{ $t('connect.step2Title') }}</h3>
            <div class="text-description">
                {{ $t('connect.step2Description') }}
            </div>
        </div>
        <el-row :guter="20">
            <el-col :span="12" :xs="24" class="mb-2 mb-sm-0">
                <InputSearch v-model="q" :placeholder="$t('connect.step1Title')" @keydown.enter="getListApps()" @search="getListApps()"></InputSearch>
            </el-col>
            <el-col :span="12" :xs="24">
                <div class="data-steps__adds">
                    <a class="icon-grid" :class="{ 'icon-grid__active': layoutStep === 1 }" href="javascript:void(0)" @click="setLayout(1)">
                        <i class="fa fa-list"></i>
                    </a>
                    <a class="icon-grid" :class="{ 'icon-grid__active': layoutStep === 2 }" href="javascript:void(0)" @click="setLayout(2)">
                        <i class="fas fa-th"></i>
                    </a>
                </div>
            </el-col>
        </el-row>
        <div class="py-2">
            <box-loading v-if="isLoading"></box-loading>
            <div v-else>
                <div class="list-workspace" v-if="layoutStep === 2">
                    <div
                        v-for="(item, index) in listApps"
                        :key="index + 'box'"
                        class="card ribbon-vertical-left-wrapper cursor-pointer group"
                        @click="emitAppData(item)"
                        :class="dataApp['app_id'] === parseInt(item['app_id']) ? 'active' : ''"
                    >
                        <div class="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary" v-if="dataApp['app_id'] === parseInt(item['app_id'])">
                            <i class="fa fa-star"></i>
                        </div>
                        <div class="job-search">
                            <div class="card-body">
                                <div class="media">
                                    <div class="media-body" style="padding-left: 25px">
                                        <h6 class="f-w-600 d-flex align-items-center">
                                            <el-icon class="el-icon-notebook-2"></el-icon>
                                            <a href="javascript:void(0)" class="text-name-space font-weight-bold hover-text" @click="showKintoneApp(item.app_id)" style="-webkit-line-clamp: 1">
                                                [{{ item.app_id }}] {{ item.name }}</a
                                            >
                                        </h6>
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="text-creator">{{ item.creator ? item.creator.name : '' }}</div>
                                            <FormatDate is-kintone :date="item.modified_at" format="YYYY/MM/DD HH:mm:DD"></FormatDate>
                                        </div>
                                    </div>
                                </div>
                                <div v-html="item.description" class="overflow_text"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="table-sm table-kb">
                    <table class="table table-hover table-common">
                        <thead>
                            <tr>
                                <th></th>
                                <th>No.</th>
                                <th>{{ $t('apps.app') }}</th>
                                <th>{{ $t('apps.creator') }}</th>
                                <th>{{ $t('apps.modifier') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item, index) in listApps"
                                :key="index + 'row'"
                                :class="dataApp['app_id'] === parseInt(item['app_id']) ? 'active' : ''"
                                @click="emitAppData(item)"
                                class="row-workspace"
                            >
                                <td>
                                    <div class="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary" v-if="dataApp['app_id'] === parseInt(item['app_id'])">
                                        <i class="fa fa-star"></i>
                                    </div>
                                </td>
                                <td class="w-10" data-title="No.">{{ index + 1 + 8 * (page - 1) }}</td>
                                <td :data-title="$t('apps.app')">
                                    <h6 @click="showKintoneApp(item.app_id)" class="text-name text-hover">[{{ item.app_id }}] {{ item.name }}</h6>
                                    <div class="description-app" v-html="item.description"></div>
                                </td>
                                <td class="w-20" :data-title="$t('apps.creator')">
                                    {{ item.creator ? item.creator.name : '' }}
                                </td>
                                <td class="w-15 text-left" :data-title="$t('apps.modifier')">
                                    {{ item.modifier ? item.modifier.name : '' }}<br />
                                    <FormatDate is-kintone :date="item.modified_at" format="YYYY/MM/DD HH:mm:DD"></FormatDate>
                                </td>
                            </tr>
                            <tr v-if="listApps.length === 0">
                                <td :colspan="5" class="text-center">
                                    <el-empty :description="$t('app.noDataSetting')"></el-empty>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <ul class="pagination m-0">
                    <li class="page-item" @click="prevPage" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#">
                            <el-icon class="el-icon-d-arrow-left"></el-icon>
                        </a>
                    </li>
                    <li class="page-item" @click="nextPage" :class="{ disabled: listApps.length < 8 }">
                        <a class="page-link" href="#">
                            <el-icon class="el-icon-d-arrow-right"></el-icon>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="card-footer footer-buttons">
            <Button @click="handlePrevStep" classes="btn-sm mr-3" type="warning"> <i class="el-icon-back"></i> {{ $t('connect.prevStep') }} </Button>
            <Button @click="handleNextStep" :disabled="!dataApp.app_id" classes="btn-sm" type="primary"> {{ $t('connect.nextStep') }} <i class="el-icon-right"></i> </Button>
        </div>
    </div>
</template>

<script>
import Button from '@/components/partials/Button';
import InputSearch from '@/components/partials/customs/InputSearch';
import { mapState } from 'vuex';
import FormatDate from '@/components/partials/FormatDate';
import BoxLoading from '@/components/partials/BoxLoading';
export default {
    name: 'step-apps',
    props: ['data'],
    components: {
        BoxLoading,
        FormatDate,
        Button,
        InputSearch
    },
    data() {
        return {
            layoutStep: parseInt(localStorage.getItem('layoutStep2')) || 2,
            q: '',
            page: parseInt(localStorage.getItem('layoutPage2')) || 1,
            limit: 8,
            currentPage: 1,
            dataApp: this.data,
            total: '',
            listApps: [],
            isLoading: false,
            checkDisabledPrev: false
        };
    },
    created() {
        this.getListApps();
    },
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    watch: {
        dataApp: {
            deep: true,
            handler: function () {
                this.$emit('update:data', this.dataApp);
            }
        }
    },
    methods: {
        getListApps() {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                if (response.status === 200) {
                    let { data } = response.data;
                    this.listApps = data.data;
                    this.currentPage = data.metadata['current_page'];
                    let i = this.listApps.findIndex((x) => parseInt(x.app_id) === this.dataApp.app_id);
                    if (i >= 0) {
                        this.dataApp.app_name = this.listApps[i].name;
                    }
                }

                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let spaceUid = this.dataApp.workspace_uid;
            if (this.dataApp.workspace_uid === null) {
                spaceUid = 'spaces';
            }
            let payload = {
                spaceId: spaceUid,
                query: this.getQuery(),
                successCallback,
                errorCallback
            };
            this.$store.dispatch('connect/getListApps', payload);
        },
        getQuery() {
            let query = 'q=' + this.q + '&page=' + this.page + '&limit=' + this.limit;
            return query;
        },
        emitAppData(o) {
            this.dataApp.app_id = parseInt(o.app_id);
            this.dataApp.app_name = o.name;
            localStorage.setItem('layoutPage2', this.page);
        },
        handlePrevStep() {
            this.$emit('prevStep');
        },
        handleNextStep() {
            this.$emit('nextStep');
        },
        setLayout(type) {
            this.layoutStep = type;
            localStorage.setItem('layoutStep2', type);
        },
        nextPage() {
            if (this.listApps.length === 8) {
                if (this.listApps.length !== 0) {
                    this.page++;
                }
                this.getListApps();
                localStorage.setItem('layoutPage2', this.page);
            }
        },
        prevPage() {
            if (this.page > 1) {
                this.page--;
                this.getListApps();
                if (this.page === 1) {
                    this.checkDisabledPrev = true;
                } else {
                    this.checkDisabledPrev = false;
                }
            }
            localStorage.setItem('layoutPage2', this.page);
        },
        showKintoneApp(id) {
            if (this.dataApp.workspace_type === 2) {
                let linkKintoneApp = this.userInfo.url_kintone + '/k/guest/' + this.dataApp.workspace_uid + '/' + id + '/';
                window.open(linkKintoneApp, '_blank');
            }
            let linkKintoneApp = this.userInfo.url_kintone + '/k/' + id;
            window.open(linkKintoneApp, '_blank');
        }
    }
};
</script>
